module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý hãng vận chuyển"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-carrier'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm\n      mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.carrierTable,
    attrs: {
      "table-name": _vm.carrierTable,
      "data-source": "carriers",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": "",
            "row-class-name": _vm.tableRowClassName
          }
        }, [_vm._v("\n          >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.carrierTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.carrierTable].current_page - 1) * _vm.dataPaginations[_vm.carrierTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "HVC",
            "width": "300"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "shipment-code-display"
              }, [_vm._v(_vm._s(scope.row.id))])]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(scope.row.name) + " (" + _vm._s(scope.row.short_name) + ")\n              ")]), _vm._v(" "), (scope.row.is_cash) ? _c('p', [_vm._v("Giao hàng ứng tiền: "), _c('i', {
                staticClass: "fa text-green fa-check"
              })]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phí"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-row', {
                attrs: {
                  "gutter": 10
                }
              }, [_c('el-col', {
                staticClass: "border-right",
                attrs: {
                  "span": 12
                }
              }, [_c('p', [_vm._v("VAT: "), _c('span', {
                staticClass: "text-red pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.vat_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Phí dịch vụ: "), _c('span', {
                staticClass: "text-red pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.service_fee, 2)))])]), _vm._v(" "), _c('p', [_vm._v("Phí bảo hiểm: "), _c('span', {
                staticClass: "text-red pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.insurrance_fee, 2)))])])]), _vm._v(" "), _c('el-col', {
                attrs: {
                  "span": 12
                }
              }, [_c('p', [_vm._v("Phí xăng dầu: "), _c('span', {
                staticClass: "text-red pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.oil_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Hệ số vùng xa: "), _c('span', {
                staticClass: "text-red pull-right"
              }, [_vm._v(_vm._s(_vm._f("percent")(scope.row.remote_area_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Cân nặng quy đổi: "), _c('span', {
                staticClass: "text-orange pull-right"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight_rate)))])])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chi tiết"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.detailCarrier(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search"
              })])]), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-carrier',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteCarrier(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Khôi phục"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.restore(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-refresh",
                attrs: {
                  "aria-hidden": "true"
                }
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Chi tiết hãng vận chuyển: ' + _vm.carrier.name,
      "visible": _vm.detailModal
    },
    on: {
      "update:visible": function($event) {
        _vm.detailModal = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carrier.logo_path,
      "width": "100",
      "height": "100",
      "alt": _vm.carrier.name,
      "onerror": "this.src='https://placeholdit.imgix.net/~text?txtsize=19&txt=carrier&w=150&h=150'"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-bold text-blue"
  }, [_vm._v(_vm._s(_vm.carrier.name))]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "display-inline",
    attrs: {
      "placement": "top",
      "content": "Tên viết tắt"
    }
  }, [_c('span', {
    staticClass: "text-green"
  }, [_vm._v(_vm._s(_vm.carrier.short_name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('table', {
    staticClass: "width-100"
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-bold"
  }, [_vm._v("Loại phí")]), _vm._v(" "), _c('td', {
    staticClass: "text-bold"
  }, [_vm._v("Giá trị")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', [_vm._v("VAT")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("percent")(_vm.carrier.vat_fee)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Phí dịch vụ")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("percent")(_vm.carrier.service_fee, 2)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Phí bảo hiểm")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("percent")(_vm.carrier.insurrance_fee, 2)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Phí xăng dầu")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("percent")(_vm.carrier.oil_fee)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Hệ số vùng xa")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("percent")(_vm.carrier.remote_area_fee)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Cân nặng quy đổi")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("gam")(_vm.carrier.weight_rate)))])])]), _vm._v(" "), (_vm.carrier.is_cash) ? _c('tr', [_c('td', [_c('span', [_vm._v("Giao hàng ứng tiền")])]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "fa fa-check text-green"
  })])]) : _vm._e()])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8e4a2fe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carrier/Carrier.vue
// module id = 727
// module chunks = 1